import React from 'react';
import { FormSubmissionPrintContextState } from './types';

export const FormSubmissionPrintContext =
  React.createContext<FormSubmissionPrintContextState>({
    updateQueryStatus: () => undefined,
  });
